export default __webpack_public_path__ + "static/media/IMG_0033_6_11zon.c328db5d.jpg";